import { VARIANTS } from './constants';

export function getVariantFromUrl(experimentId: string): VARIANTS | null {
  try {
    const url = new URL(window.location.href);
    const searchParamValue = url.searchParams.get(`exp_${experimentId}`);

    if (
      searchParamValue === 'variant1' ||
      searchParamValue === 'variant2' ||
      searchParamValue === 'control'
    ) {
      return VARIANTS[searchParamValue];
    }

    return null;
  } catch {
    return null;
  }
}
